export default "__VITE_ASSET__7c526976__"